import { formatData, checkErrorData } from "./utils";

export function fetchProducts(){
    console.log("FIRED ACTION FETCH PRODUCTS" )
    return async function(dispatch){
        dispatch({
            type: "FETCH_PRODUCTS_START",
            payload: ""
            
        })
        try {
            const response = await fetch('/stocks/getList',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    page:"products",
                }),
                credentials: 'same-origin',
            }); 
            
            const prodsList = await response.json()
            console.log(prodsList)

            if(!prodsList.error){ // no errors
                
                dispatch(getProducts(formatData(prodsList.reverse()) ))
                dispatch({ type: "FETCH_PRODUCTS_FULFILLED", payload:"" })
                console.log(" products fetched")
                
                // dispatch(fetchStocks())
            
            } else {
                dispatch({
                    type: "FETCH_PRODUCTS_ERROR",
                    payload: prodsList.error.message
                })
            }
            
        } catch (err) {
            dispatch({
                type: "FETCH_PRODUCTS_ERROR",
                payload: err
                
            })
        }
    }
}
export function createProductOld(newProd){
    // console.log("FIRED ACTION CREATE PRODUCT", newProduct)
    return async function(dispatch){
        dispatch({
            type: "CREATE_PRODUCT_START",
            payload: ""
            
        })
        try {
            try {
                for(let i = 0; i < newProd.photos.length; i++){
                    let photo = newProd.photos[i]
                    console.log("[INFO] PRODUCTS submit upload photos ", i, photo, photo.file);

                    const resPhotos = await fetch('/stocks/uploadPhotos', {
                        method: 'POST',
                        headers: { 
                            'Content-Type': 'application/json',
                            //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                        },
                        body:JSON.stringify({file : photo}),
                        credentials: 'same-origin',
                    }); 

                    const bodyRes = await resPhotos.json()
                    console.log("[INFO] PRODUCTS submit upload photos res", bodyRes)
                    if (bodyRes.path) {
                        newProd.photos[i] = {filename:bodyRes.path}
                    } 
                    else {
                        console.log("[ERROR] while uploading photo ", i+1);
                        dispatch({
                            type: "CREATE_PRODUCT_ERROR",
                            payload: bodyRes.error.message
                        })
                        newProd.photos[i] = {filename:""}
                    }
                }
                
            } catch (error) {
                console.log("[ERROR] SUBMIT PHOTO UPLOAD", error);
                dispatch({ type: "CREATE_PRODUCT_ERROR", payload: error })
            }
            const response = await fetch('/stocks/addData',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    page:"products",
                    data:newProd
                }),
                credentials: 'same-origin',
            }); 
            
            const createdProduct = await response.json()
            console.log(createdProduct)// createdProduct returns new object created

            if(createdProduct.id){ // no errors, return new Object
                createdProduct.src = [] // array to save photos src URI
                dispatch({
                    type: "NEW_PRODUCT",
                    payload: createdProduct
                    
                })
                dispatch({ type: "CREATE_PRODUCT_FULFILLED", payload:"" })
                console.log("Product created")
            } else {
                dispatch({
                    type: "CREATE_PRODUCT_ERROR",
                    payload: createdProduct.error.message
                })
            }
            
        } catch (err) {
            console.log("[ERROR] SUBMIT PRODUCT ", err);
            dispatch({ type: "CREATE_PRODUCT_ERROR", payload: err })
        }
    }
}
export function DuplicateProductFromID(prodID){
    // console.log("FIRED ACTION CREATE PRODUCT", newProduct)
    return async function(dispatch){
        dispatch({
            type: "CREATE_PRODUCT_START",
            payload: ""
            
        })
        try {
            const response = await fetch('/stocks/addData',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    page:"products/duplicatefromid",
                    data:prodID
                }),
                credentials: 'same-origin',
            }); 
            
            const createdProduct = await response.json()
            console.log(createdProduct)// createdProduct returns new object created

            if(createdProduct.id){ // no errors, return new Object
                createdProduct.src = [] // array to save photos src URI
                dispatch({
                    type: "NEW_PRODUCT",
                    payload: createdProduct
                    
                })
                dispatch({ type: "CREATE_PRODUCT_FULFILLED", payload:"" })
                console.log("Product created")
                return "OK"
            } else {
                dispatch({
                    type: "CREATE_PRODUCT_ERROR",
                    payload: createdProduct.error.message
                })
            }
            throw new Error(createdProduct.error.message)
        } catch (err) {
            console.log("[ERROR] SUBMIT PRODUCT ", err);
            dispatch({ type: "CREATE_PRODUCT_ERROR", payload: err })
            throw err
        }
    }
}

export function createProduct(newProd){
    // console.log("FIRED ACTION CREATE PRODUCT", newProduct)
    return async function(dispatch){
        dispatch({
            type: "CREATE_PRODUCT_START",
            payload: ""
            
        })
        try {
            const response = await fetch('/stocks/addData',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    page:"products",
                    data:newProd
                }),
                credentials: 'same-origin',
            }); 
            
            // Check if response is successful
            if (!response.ok) {
                const errorText = await response.text();
                let errorMessage = "Erreur lors de la création du produit";
                
                if (response.status === 409) {
                    // Conflict - duplicate product name
                    errorMessage = errorText || "Un produit avec ce nom existe déjà dans votre compte";
                } else if (response.status === 404) {
                    errorMessage = errorText || "Erreur lors de la création du produit";
                } else {
                    errorMessage = errorText || `Erreur ${response.status}: ${response.statusText}`;
                }
                
                dispatch({
                    type: "CREATE_PRODUCT_ERROR",
                    payload: errorMessage
                })
                return;
            }
            
            const createdProduct = await response.json()
            console.log(createdProduct)// createdProduct returns new object created

            if(createdProduct.id){ // no errors, return new Object
                createdProduct.src = [] // array to save photos src URI
                dispatch({
                    type: "NEW_PRODUCT",
                    payload: createdProduct
                    
                })
                dispatch({ type: "CREATE_PRODUCT_FULFILLED", payload:"" })
                console.log("Product created")
            } else {
                dispatch({
                    type: "CREATE_PRODUCT_ERROR",
                    payload: createdProduct.error?.message || "Erreur lors de la création du produit"
                })
            }
            
        } catch (err) {
            console.log("[ERROR] SUBMIT PRODUCT ", err);
            dispatch({ type: "CREATE_PRODUCT_ERROR", payload: err.message || err })
        }
    }
}
export function deleteProduct(deleteProd){
    return async function(dispatch){
        try {
            const response = await fetch('/stocks/addData',{
                method:'DELETE',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    page:"products",
                    data:deleteProd
                }),
                credentials: 'same-origin',
            }); 
            
            const resp = await response.json()
            console.log(resp)// createdProduct returns new object created

            if(resp==="OK"){ // no errors, return new Object
                dispatch({
                    type: "DELETE_PRODUCT",
                    payload: deleteProd
                    
                })
                return "OK"
            }
            throw new Error(resp.error.message);
        } catch (err) {
            throw err;
        }
    }
}
export function duplicateProduct(newProd){
    return async function(dispatch){
        dispatch({
            type: "DUPLICATE_PRODUCT_START",
            payload: ""
            
        })
        try {
            const response = await fetch('/stocks/addData',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    page:"products/duplicate",
                    data:newProd
                }),
                credentials: 'same-origin',
            }); 
            
            // Check if response is successful
            if (!response.ok) {
                const errorText = await response.text();
                let errorMessage = "Erreur lors de la duplication";
                
                console.log('duplicateProduct - HTTP Error:', response.status, errorText);
                
                if (response.status === 409) {
                    // Conflict - duplicate product name
                    errorMessage = errorText || "Un produit avec ce nom existe déjà dans votre compte";
                } else if (response.status === 404) {
                    errorMessage = errorText || "Erreur lors de la duplication";
                } else {
                    errorMessage = errorText || `Erreur ${response.status}: ${response.statusText}`;
                }
                
                console.log('duplicateProduct - Dispatching error:', errorMessage);
                dispatch({
                    type: "DUPLICATE_PRODUCT_ERROR",
                    payload: errorMessage
                })
                throw new Error(errorMessage);
            }
            
            const createdProduct = await response.json()
            console.log(createdProduct)// createdProduct returns new object created

            if(createdProduct.id){ // no errors, return new Object
                // createdProduct.src = [] // array to save photos src URI
                // dispatch({
                //     type: "DUPLICATE_PRODUCT",
                //     payload: createdProduct
                    
                // })
                // update match product
                dispatch({ type: "DUPLICATE_PRODUCT_FULFILLED", payload:"" })
                console.log("Product duplicated successfully")
                return createdProduct; // Return the created product for success handling
            } else {
                const errorMessage = createdProduct.error?.message || createdProduct.error || "Erreur lors de la duplication";
                dispatch({
                    type: "DUPLICATE_PRODUCT_ERROR",
                    payload: errorMessage
                })
                throw new Error(errorMessage); // Throw error to be caught by calling component
            }
            
        } catch (err) {
            console.log("[ERROR] DUPLICATE PRODUCT ", err);
            const errorMessage = err.message || "Erreur de connexion lors de la duplication";
            console.log("[ERROR] DUPLICATE PRODUCT - Dispatching error:", errorMessage);
            dispatch({ 
                type: "DUPLICATE_PRODUCT_ERROR", 
                payload: errorMessage 
            })
            throw err; // Re-throw to allow calling component to handle
        }
    }
}
export function updateProduct(data) {
    return async function(dispatch){
        try {
            dispatch({ type: "UPDATE_PRODUCT_START", payload: "" })

            console.log("update Product START")
            const response = await fetch('/stocks/single',{
                method:'PUT',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify(data),
                credentials: 'same-origin',
            }); 
            
            const updatedProduct = await response.json()
            
            console.log({updatedProduct});

            if(checkErrorData(updatedProduct, "UPDATE_PRODUCT_ERROR", dispatch ) ) {
                dispatch({
                    type: "UPDATE_PRODUCT",
                    payload: data
                })
                dispatch({ type: "UPDATE_PRODUCT_FULFILLED", payload: "" })
            }

        } catch(err) {
            console.log("[ERROR] update product ", err);
            dispatch({
                type: "UPDATE_PRODUCT_ERROR",
                payload: err
                
            })
        }
    }
}
export function getProducts(products){
    // console.log("FIRED ACTION GET PRODUCT", products)
    return {
        type: "GET_PRODS",
        payload: products
        
    }
}
export function setPhotoProd(prodID,URI){
    return {
        type: "SET_MAIN_PHOTO",
        payload: {prodID, URI}
        
    }
}

export function getAllPhotos() {
    return async function(dispatch){        
        let response = await fetch("/stocks/getAllPhotos",{
            method:'GET',
            headers: { 
                'Content-Type': 'application/json',
                //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
            },
            credentials: 'same-origin',
        })
        let res = await response.json() // {key: "product_id", value: "URI"}
        if(res.photoList){
            dispatch({ type: "SET_ALL_PHOTOS", payload: res.photoList })
            dispatch({ type: "PRODUCT_PHOTOS_FULFILLED", payload: "" })
        } else {
            dispatch({ type: "PRODUCT_PHOTOS_ERROR", payload: res.error.message })
        }
        
    }
}
export function getPhotoProd(prodID,filename, main = false) {
    return async function(dispatch){        
        let response = await fetch("/stocks/getPhotos",{
            method:'POST',
            headers: { 
                'Content-Type': 'application/json',
                //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
            },
            body:JSON.stringify({
                path:filename
            }),
            credentials: 'same-origin',
        })
        let image = await response.json()
        if(main){
            dispatch(setPhotoProd(prodID, image.uri))
        } else {
            dispatch({
                type: "SET_PHOTOS",
                payload: {prodID, URI:image.uri}
                
            })
        }
    }
}
export function addPhotosProduct(files){
    return async function(dispatch){
        dispatch({
            type: "ADD_PHOTOS_PRODUCT_START",
            payload: ""
            
        })
        try {
            const response = await fetch('/stocks/addData',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    page:"products/add/files",
                    data:files
                }),
                credentials: 'same-origin',
            }); 
            
            const updatedProduct = await response.json()
            console.log(updatedProduct)// updatedProduct returns new object created

            if(updatedProduct.id){ // no errors, return new Object
                dispatch({
                    type: "UPDATE_PRODUCT",
                    payload: updatedProduct
                    
                })
                dispatch({ type: "ADD_PHOTOS_PRODUCT_FULFILLED", payload:"" })
                console.log("Product updated")

            } else {
                dispatch({
                    type: "ADD_PHOTOS_PRODUCT_ERROR",
                    payload: updatedProduct.error.message
                    
                })
                
            }
            
        } catch (err) {
            console.log("[ERROR] files PRODUCT ", err);
            dispatch({
                type: "ADD_PHOTOS_PRODUCT_ERROR",
                payload: err
                
            })
        }
    }
}
export function updatePhotosProduct(files){
    return async function(dispatch){
        dispatch({
            type: "ADD_PHOTOS_PRODUCT_START",
            payload: ""
            
        })
        try {
            const response = await fetch('/stocks/addData',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    page:"products/update/files",
                    data:files
                }),
                credentials: 'same-origin',
            }); 
            
            const updatedProduct = await response.json()
            console.log(updatedProduct)// updatedProduct returns new object created

            if(updatedProduct.id){ // no errors, return new Object
                dispatch({
                    type: "UPDATE_PRODUCT",
                    payload: updatedProduct
                    
                })
                dispatch({ type: "ADD_PHOTOS_PRODUCT_FULFILLED", payload:"" })
                console.log("Product updated")

            } else {
                dispatch({
                    type: "ADD_PHOTOS_PRODUCT_ERROR",
                    payload: updatedProduct.error.message
                    
                })
                
            }
            
        } catch (err) {
            console.log("[ERROR] files PRODUCT ", err);
            dispatch({
                type: "ADD_PHOTOS_PRODUCT_ERROR",
                payload: err
                
            })
        }
    }
}export function resetProductState(){
    return function(dispatch){
        dispatch({
            type: "RESET_PRODUCT_STATE",
            payload: ""
        })
    }
}
